import { Context } from "@nuxt/types";

import Api from "@/utils/api";

const DEFAULT_POST_LIMITS = 36;

export default class PostsApi extends Api {
  readonly url = "/v3/posts";

  constructor($axios: Context["$axios"]) {
    super("postService", $axios);
  }

  async get(profileId: string, params: ProfilePostsMeta | null) {
    return await this.request<ManyPostsResponse>({
      method: "GET",
      params: {
        profiles: [profileId],
        limit: params?.limit || DEFAULT_POST_LIMITS,
        next: params?.next || null,
        includes: params?.includes,
      },
    });
  }
}
